import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {NMC} from './NMC';
import {TelegramService} from '../../pages/page-telegram/telegram.service';
import {AllService} from '../../services/all.service';
import {environment} from '../../../environments/environment';
import {ThemeService} from '../../services/theme.service';
import {NzMarks} from 'ng-zorro-antd/slider';
import {SettingsService} from '../../services/settings.service';
import {AllMessengersService} from '../../pages/page-start/all-messengers.service';
import {Avatar, IMessengerConnector} from '../../types/all.type';
import {log} from '../../functions';
import {takeUntil} from 'rxjs/operators';
import {InterfaceService} from '../../services/interface.service';
import {AuthService} from '../../modules/auth/services/auth.service';
import {NotifierWrapService} from '../../services/notifier-wrap.service';
import { AppService } from '../../services/app.service';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  public nmc = NMC;
  public loadingBackground: boolean;
  public isLoaded = false;
  public isInit = false;
  public marks: NzMarks = {
    0: '0°C',
    26: '26°C',
    37: '37°C',
    100: {
      style: {
        color: '#f50'
      },
      label: '<strong>100°C</strong>'
    }
  };
  @Input() Service: IMessengerConnector;
  public initServiceType: string;
  environment = environment;
  public isEditProfile = false;
  public isSavingProfile = false;

  constructor(
    private appService: AppService,
    public notifierWrapService: NotifierWrapService,
    public authService: AuthService,
    public interfaceService: InterfaceService,
    public allMessengersService: AllMessengersService,
    public settingsService: SettingsService,
    public themeService: ThemeService,
    public allService: AllService,
    public cd: ChangeDetectorRef,
  ) {
  }

  init(visible: boolean): void {
    if (visible && !this.isLoaded) {
      this.Service.getProfile('profile').pipe(takeUntil(this.destroy$)).subscribe(
        (profile) => {
          log('profile', profile);
          this.isLoaded = true;
          this.Service.arProfile = profile;
          this.Service.isLoadedProfile = true;
          // TODO переместить
          const phone = this.Service.arProfile?.phone_number?.toString();
          if (phone && phone.indexOf('+') === -1) {
            this.Service.arProfile.phone_number = '+' + phone;
          }
          setTimeout(() => {
            this.cd.detectChanges();
          }, 1000);
        },
        (error) => {
          this.isLoaded = false;
          this.Service.isLoadedProfileError = error;
          this.cd.detectChanges();
        }
      );
    }
  }

  ngOnInit(): void {

    /*this.Service.arProfile.phone_number_show = this.Service.arProfile?.phone_number;
        const phone_number = this.formatPhoneNumber(this.Service.arProfile?.phone_number);
        // alert(phone_number);
        if(!phone_number){
          this.Service.arProfile.phone_number_show = phone_number;
        }*/

    this.initServiceType = this.Service.type;
    this.fixStartService();
    this.allService.setService$.pipe(takeUntil(this.destroy$)).subscribe((type) => {
      this.Service = this.allMessengersService.Service;
      this.cd.detectChanges();
    });
    this.init(true);
    this.allService.login$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cd.detectChanges();
      this.fixStartService();
    });
    this.allService.logout$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cd.detectChanges();
    });
  }
  fixStartService(): void {
    if (this.Service instanceof AllMessengersService) {
      const arServicesAuthorized = this.allMessengersService.arServicesAuthorized;
      if (arServicesAuthorized?.length > 0) {
        this.Service = arServicesAuthorized[0];
      }else{
        this.Service = this.allMessengersService.Service;
      }
      console.log('Set service to profile', this.Service.type);
    }
  }
  set devMode(val) {
    localStorage.setItem('devMode', val ? 'Y' : 'N');
    const electron = window?.require('electron');
    electron.ipcRenderer.send('dev.mode', val);
  }

  get devMode() {
    return localStorage.getItem('devMode') !== 'N';
  }

  toggleService(Service: IMessengerConnector): void {
    this.Service = Service;
    this.cd.detectChanges();
    this.interfaceService.profileSetService$.next();
  }



  setBackground(i: number) {
    this.themeService.activeBackground = i;
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  editProfile(): void {
    this.isSavingProfile = true;
    if (this.Service instanceof TelegramService) {
      this.Service.editProfile({
        name: this.Service.arProfile.name,
        id: this.Service.arProfile.id,
        description: this.Service.arProfile.description
      }).pipe(takeUntil(this.destroy$)).subscribe((arProfile) => {
        this.Service.arProfile = arProfile;
        this.isEditProfile = false;
        this.isSavingProfile = false;
        this.cd.detectChanges();
      }, error => {
        this.isSavingProfile = false;
        this.interfaceService.errorHandling(error);
        this.cd.detectChanges();
      });
    }
  }

  get isTelegramService(): boolean {
    return (this.Service instanceof TelegramService);
  }

  toggleEditProfile(): void {
    this.isEditProfile = !this.isEditProfile;
    this.cd.detectChanges();
  }

  // Avatar
  get descriptionPlacehilder(): string {
    return this.interfaceService.isTelesellerDomain ?
      'Любые подробности, например: информация о вашем бзнесе или ссылка на канал' :
      'Любые подробности, например: возраст, род занятий или город.';
  }



  reloadProfile(): void {
    this.Service.loadProfile().subscribe(() => {
      this.cd.detectChanges();
    });
  }

  logout() {
    if (!this.authService.logout(this.Service)) {
      this.notifierWrapService.notify('error', 'Для полного выхода обратитесь в техническую поддержку, функция временно отключена.');
    }
    this.Service = this.allMessengersService.arServicesAuthorized[0];
    this.cd.detectChanges();
  }

  openSpamBot() {
    const findChat = this.allService.arChat.find((chat) => {
      return chat.username === 'SpamBot' && chat.service_type === this.Service.type;
    });
    if (!findChat) {
      this.allService.arChat.unshift({
        id: 'SpamBot',
        name: {
          first: 'Spam Info Bot',
          last: ''
        },
        title: '@SpamBot',
        username: 'SpamBot',
        service_type: this.Service.type,
        is_pinned: true,
        is_support: true,
        type: 'bot',
        last_message: {
          time: 9999999999999,
          text: '',
          text_list: 'Разблокировать аккаунт',
          chat_id: 'SpamBot',
          date: 9999999999999,
          id: 0,
          out: false
        }
      });
    } else {
      // findChat.service_type = this.Service.type;
    }
    this.Service.message = '/start';
    this.appService.openChat('@SpamBot', this.Service.type);
    this.Service._openChatId = 'SpamBot';
  }
}
